import script from "./patientSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./patientSearch.vue?vue&type=script&setup=true&lang=ts"

import "./patientSearch.vue?vue&type=style&index=0&id=0e371c62&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e371c62"]])

export default __exports__